import { render, staticRenderFns } from "./ReferralReport.vue?vue&type=template&id=e94ed404&"
import script from "./ReferralReport.vue?vue&type=script&lang=js&"
export * from "./ReferralReport.vue?vue&type=script&lang=js&"
import style0 from "./ReferralReport.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsItems } from 'vuetify/lib/components/VTabs';
installComponents(component, {VContainer,VTab,VTabItem,VTabs,VTabsItems})
